import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRotaryScreen = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 65,
	viewBox: "0 0 100.0 65.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: 25,
			width: 100,
			height: 40,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 50,
			cy: 25,
			rx: 25,
			ry: 25,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: 25,
			width: 100,
			height: 40,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgRotaryScreen;
